import { Button } from "antd";
import { useCallback } from "react";
import { openPopup2 } from "../../../contexts/PopupContext";
import { callEventTrackingOp, INextStatePayload, useTrackingOp } from "../../../contexts/TrackingOpContext";
import ConfirmNextState from "./StepControl/ConfirmNextState";
import styles from "./style.module.scss";

interface IProps {
    name?: string;
    payload?: Partial<INextStatePayload>;
    justify?: "start" | "end";
    message?: string

    onClick?: () => void;
}

export default function FinishStepButton({ name, payload = {}, onClick, justify = "end", message }: IProps) {
    const [loading] = useTrackingOp(state => state.loading);
    const { nextState } = callEventTrackingOp();

    const handleClick = useCallback(() => {
        openPopup2(<ConfirmNextState
            isComplete={false}
            name={name}
            message={message}
            onOk={() => nextState(payload)}
        />)
    }, [name, nextState, payload, message]);

    if (!name)
        return null;

    return <>
        <div className="min-h-[20px] flex-1" />
        <div className={`flex ${justify === "start" ? "justify-start" : "justify-end"}`}>
            <Button className={styles.finishBt} onClick={onClick || handleClick} loading={!!loading}>
                {name}
            </Button>
        </div>
    </>
}
